import { h } from 'preact';
import { ChatBubble } from '../ChatBubble';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'ChatBubble',
  category: '💬 Chat',
  description: 'Balão de mensagem para chat com variante user e assistant, timestamp e métricas',
  usedIn: ['Chat', 'ChatHubPage'],
  example: () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12, maxWidth: 500 }}>
      <ChatBubble isUser={true} timestamp="12:30">Olá, como vai?</ChatBubble>
      <ChatBubble isUser={false} timestamp="12:31">Tudo bem! Como posso ajudar?</ChatBubble>
    </div>
  ),
};
